import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { CruiseSaleFormType } from '../form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<CruiseSaleFormType>();
  const [cruiseSales, otherCost, discount] = useWatch({
    control,
    name: ['cruiseSales', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = cruiseSales.reduce((prev, cs) => {
      const subtotalGuest = cs.isGroupedPrice
        ? (cs.cruiseSaleDetails[0].basicFare || 0) +
          (cs.cruiseSaleDetails[0].portCharge || 0) +
          (cs.cruiseSaleDetails[0].tax || 0) +
          (cs.cruiseSaleDetails[0].tipping || 0)
        : cs.cruiseSaleDetails.reduce(
            (prev, csd) =>
              prev +
              (csd.basicFare || 0) +
              (csd.portCharge || 0) +
              (csd.tax || 0) +
              (csd.tipping || 0),
            0,
          );

      const subtotalAddOns = cs.cruiseSaleAddOns.reduce(
        (prev, csao) => prev + (csao.price || 0),
        0,
      );
      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [cruiseSales, discount, otherCost, setValue]);

  return data;
}
